module.exports = __webpack_public_path__ + "img/hdp-4.c6a02270.jpeg";